export const TryDemoIcon = ({ stroke = '#A498FF' }) => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke={stroke} strokeOpacity="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8844 12.443H17.6055V9H15.8844V12.443ZM9 17.6076H12.4422V15.8861H9V17.6076ZM13.0942 14.3122L10.6605 11.8771L11.8773 10.66L14.3109 13.0951L13.0942 14.3122ZM11.8772 22.8332L10.6604 21.6161L13.094 19.181L14.3109 20.3981L11.8772 22.8332ZM20.3962 14.3122L19.1793 13.0951L21.613 10.66L22.8298 11.8771L20.3962 14.3122ZM18.2097 26L14.9532 14.9497L26 18.2101L23.4692 20.7408L25.8795 23.1423L23.1421 25.8795L20.7405 23.4694L18.2097 26Z"
        fill="#05050D"
      />
    </svg>
  );
};
